const DATA_VERSION = "2.5.0";
const DATA_VERSION_LS_LEY = "scalar_api_client_data_version";
export {
  DATA_VERSION,
  DATA_VERSION_LS_LEY
};
//# sourceMappingURL=data-version.js.map
